import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

import model from './model'

Vue.use(Vuex)

// const modulesFiles = require.context('./module', false, /\.js$/);
// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
//   const value = modulesFiles(modulePath);
//   modules[moduleName] = value.default;
//   return modules;
// }, {});

export default new Vuex.Store({
  state: {
    lang: 'cn',
    showSubscribeMask: false // 设置是否显示订阅遮罩层 左侧菜单与顶部导航，应用在IFRAME
  },
  getters,
  actions,
  mutations,
  modules: {
    ...model
  },
  plugins: [
    createPersistedState({
      // storage: window.localStorage,
      storage: window.sessionStorage,
      reducer (val) {
        return {
          lang: val.lang,
          // 只储存state中的user,spacefilter
          user: val.user,
          spacefilter: val.spacefilter
        }
      }
    })
  ]
})
